export const DEFAULT_TITLE_TEXT = 'DEFAULT LABEL'
